import { ThemeMode } from '../../theme-mode';

// A chart image may have a dark render beside it, at images/dark/<same file name>. Both globs
// resolve to the URLs the pages import, so the light URL a page passes is the lookup key.
const light = import.meta.glob<string>('/src/**/images/*.webp', { eager: true, import: 'default' });
const dark = import.meta.glob<string>('/src/**/images/dark/*.webp', {
  eager: true,
  import: 'default',
});

const darkByLight = new Map(
  Object.entries(dark).flatMap(([path, url]) => {
    const lightUrl = light[path.replace('/images/dark/', '/images/')];
    return lightUrl ? [[lightUrl, url] as const] : [];
  }),
);

export const themedSrc = (src: string, mode: ThemeMode): string =>
  (mode === 'dark' && darkByLight.get(src)) || src;
